var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXlm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.036 9.35442L20.5074 10.6594L8.29713 16.9594C8.25584 16.6404 8.23507 16.319 8.23494 15.9973C8.23661 14.7136 8.56932 13.4527 9.20011 12.3393C9.8309 11.226 10.7379 10.2989 11.8312 9.64986C12.9246 9.00084 14.1663 8.65242 15.4335 8.63912C16.7007 8.62582 17.9493 8.94809 19.0557 9.57402L20.503 8.82702L20.7189 8.71542C19.3931 7.74062 17.827 7.15613 16.1937 7.02656C14.5604 6.89699 12.9236 7.22738 11.4641 7.98121C10.0046 8.73505 8.77931 9.88297 7.92359 11.2981C7.06787 12.7132 6.61508 14.3405 6.61525 16C6.61525 16.2292 6.62384 16.4575 6.64101 16.6849C6.66507 17.0069 6.59457 17.329 6.43837 17.6105C6.28217 17.8921 6.04726 18.1205 5.7632 18.2671L5 18.6613V20.5L7.24695 19.3399L7.97461 18.9637L8.69161 18.5938L21.5638 11.95L23.0103 11.2039L26 9.66042V7.82262L23.036 9.35442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 11.5L9.42283 20.05L7.97639 20.7979L5 22.3342V24.1711L7.95596 22.6456L10.4846 21.3406L22.7073 15.0316C22.7486 15.3527 22.7694 15.6762 22.7695 16C22.7687 17.2852 22.4361 18.5478 21.8047 19.6625C21.1733 20.7772 20.265 21.7052 19.1701 22.3544C18.0752 23.0037 16.8317 23.3515 15.563 23.3634C14.2944 23.3753 13.0447 23.0509 11.9381 22.4224L11.8493 22.4701L10.2802 23.2801C11.6057 24.2549 13.1715 24.8396 14.8045 24.9695C16.4375 25.0993 18.0742 24.7694 19.5337 24.0161C20.9932 23.2628 22.2187 22.1154 23.0748 20.7008C23.9309 19.2861 24.3842 17.6593 24.3848 16C24.3848 15.7687 24.3759 15.5374 24.359 15.3088C24.335 14.9869 24.4054 14.665 24.5614 14.3835C24.7174 14.102 24.9521 13.8734 25.2359 13.7266L26 13.3324V11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 18,
    fill: "white",
    transform: "translate(5 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXlm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/XLM.7cd684e6560bbffd1b5de9beff12a9d2.svg";